import axios from "axios";

const http = axios.create({
  baseURL: "https://sramidcard.in/api/",
  // ❌ Content-Type हटाओ
}); 

http.interceptors.request.use(
  (config) => {
    let user = null;
    const rawUser = localStorage.getItem("user");
    if (rawUser) {
      try {
        user = JSON.parse(rawUser);
      } catch {
        user = null;
      }
    }
    const token = user?.token || localStorage.getItem("token");

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default http;

